export default "__VITE_ASSET__CPQYoaCe__"